/* Load the optional desktop scroll enhancement after the initial page workload.
   Native scrolling remains available while loading, on mobile, and on failure. */
(function () {
  'use strict';

  var script = document.currentScript;
  if (!script || !window.matchMedia || window.__clownDesktopScrollLoader) return;
  var lenisSrc = script.dataset.lenisSrc;
  var smoothScrollSrc = script.dataset.smoothScrollSrc;
  if (!lenisSrc || !smoothScrollSrc) return;
  window.__clownDesktopScrollLoader = true;

  var desktop = window.matchMedia('(min-width: 1024px) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
  var pageLoaded = document.readyState === 'complete';
  var scheduled = false;
  var loading = false;
  var finished = false;

  function stopListening() {
    finished = true;
    if (desktop.removeEventListener) desktop.removeEventListener('change', schedule);
    else if (desktop.removeListener) desktop.removeListener(schedule);
  }

  function appendScript(source, loaded) {
    var dependency = document.createElement('script');
    dependency.src = source;
    dependency.async = true;
    dependency.onload = loaded;
    dependency.onerror = stopListening;
    document.head.appendChild(dependency);
  }

  function loadBootstrap() {
    loading = false;
    if (typeof window.Lenis !== 'function') {
      stopListening();
      return;
    }
    // Recheck eligibility: the viewport can change during the library request.
    if (!desktop.matches) return;
    if (window.clownLenis) {
      stopListening();
      return;
    }
    loading = true;
    appendScript(smoothScrollSrc, stopListening);
  }

  function load() {
    scheduled = false;
    if (finished || loading || !desktop.matches) return;
    if (window.clownLenis) {
      stopListening();
      return;
    }
    if (typeof window.Lenis === 'function') loadBootstrap();
    else {
      loading = true;
      appendScript(lenisSrc, loadBootstrap);
    }
  }

  function schedule() {
    if (!pageLoaded || !desktop.matches || finished || loading || scheduled) return;
    scheduled = true;
    if (window.requestIdleCallback) window.requestIdleCallback(load, { timeout: 2000 });
    else window.setTimeout(load, 200);
  }

  if (desktop.addEventListener) desktop.addEventListener('change', schedule);
  else if (desktop.addListener) desktop.addListener(schedule);

  if (pageLoaded) schedule();
  else window.addEventListener('load', function () {
    pageLoaded = true;
    schedule();
  }, { once: true });
})();
